// CMS format: https://bluebutton.cms.gov/data-dictionary/bene-mbi-id/
const MBI_PATTERN = /^[1-9][AC-HJKMNP-RT-Y][0-9AC-HJKMNP-RT-Y][0-9][AC-HJKMNP-RT-Y][0-9AC-HJKMNP-RT-Y][0-9][AC-HJKMNP-RT-Y]{2}[0-9]{2}$/;

export const normalizeMBI = (value: string): string =>
  value.replace(/[\s-]/g, '').toUpperCase();

export const mbiValidationError = (value: string): string | undefined => {
  const mbi = normalizeMBI(value);
  if (!mbi) return 'Enter a Medicare Beneficiary Identifier (MBI).';
  if (!/^[1-9]/.test(mbi))
    return 'Enter a valid 11-character MBI starting with a digit from 1 to 9.';
  if (!MBI_PATTERN.test(mbi))
    return 'Enter a valid 11-character MBI. Letters B, I, L, O, S, and Z are not allowed.';
  if (mbi === '1EG4TE5MK72')
    return 'This is the CMS example MBI. Enter the beneficiary’s actual MBI.';
  return undefined;
};
